import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSecurityIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.50016 9.58314L9.16683 11.2498L12.9168 7.49981M16.6668 9.99981C16.6668 14.0902 12.2052 17.0651 10.5818 18.0122C10.3973 18.1198 10.3051 18.1737 10.1749 18.2016C10.0739 18.2232 9.92646 18.2232 9.82543 18.2016C9.69524 18.1737 9.603 18.1198 9.4185 18.0122C7.79513 17.0651 3.3335 14.0902 3.3335 9.99981V6.01448C3.3335 5.34822 3.3335 5.01509 3.44246 4.72873C3.53872 4.47576 3.69515 4.25004 3.89821 4.07109C4.12808 3.86851 4.43999 3.75154 5.06383 3.5176L9.532 1.84204C9.70524 1.77707 9.79187 1.74459 9.88098 1.73171C9.96003 1.72029 10.0403 1.72029 10.1193 1.73171C10.2085 1.74459 10.2951 1.77707 10.4683 1.84204L14.9365 3.5176C15.5603 3.75154 15.8722 3.86851 16.1021 4.07109C16.3052 4.25004 16.4616 4.47576 16.5579 4.72873C16.6668 5.01509 16.6668 5.34822 16.6668 6.01448V9.99981Z",
		stroke: "currentColor",
		strokeWidth: 1.25,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgSecurityIcon;
